import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class SystemSetting implements ViewModel {
  friendlyTypeNameSingular = 'System Setting';
  apiRoute = CONFIG.apiRoutes.systemConfigurationGetAll;

  public systemConfigurationId: string;
  public name: string;
  public value: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.systemConfigurationId = data.systemConfigurationId;
    this.name = data.name;
    this.value = data.value;
  }
}
